'use strict';

module.exports = {
  toDate: function(uxTimestamp) {
    return new Date(uxTimestamp * 1000);
  },
  fromDate: function(date) {
    return date.getTime() / 1000;
  }
};
